import React, { Fragment, useState } from 'react'
import styled from 'styled-components'
import { Section } from 'fbk-components'
import { TitleWithBorder, NewsItem, Button, GoBack } from 'components'
import { NewsData } from 'types'
import { getNewsList } from 'api'
import { spacings } from 'theme'
import { getNewsMonth } from 'utils/helpers'

interface NewsItem {
  date: string
  title: string
  text: string
}

const Wrapper = styled(Section)`
  margin-top: 60px;

  ${Button} {
    color: ${({ theme }) => theme.colors.primary};
    ${spacings('margin-top', 'm')}

    svg .path {
      stroke: ${({ theme }) => theme.colors.primary} !important;
    }
  }

  .go-back {
    display: none;
  }

  .public-month-title {
    width: 100%;
    margin: 24px 0 40px;
    font-family: ${({ theme }) => theme.fonts.main};
    font-size: 24px;
    line-height: 28px;
  }

  @media (min-width: 768px) {
    padding-top: 40px;
    margin-top: 80px;

    .public-month-title {
      margin-top: 40px;

      :first-child {
        margin-top: 0;
      }
    }

    ${Button} {
      width: calc(50% - 20px);
    }

    .go-back {
      display: inline-block;
      margin-bottom: 40px;
    }

    .news-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }

  @media (min-width: 992px) {
    ${Button} {
      :hover,
      :active,
      :disabled {
        color: #fff !important;

        svg .path {
          stroke: #fff !important;
        }
      }
    }
  }
`

interface Props {
  data: NewsData
  goBackProps: any
}

const NewsList = ({ data, goBackProps }: Props) => {
  const [isLoading, setLoading] = useState(false)
  const [newsData, setNewsData] = useState<NewsData>(data)
  const [nextPage, setNextPage] = useState(3)

  const getMonthTitle = getNewsMonth()

  const {
    meta: { total_count },
    items = [],
  } = newsData

  const fetchMore = async () => {
    try {
      setLoading(true)

      const newData = await getNewsList({ page: nextPage })

      setNextPage(value => value + 1)

      setNewsData({ ...newsData, items: [...items, ...newData.items] })
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Wrapper space="xl">
      <div className="go-back">
        <GoBack {...goBackProps} />
      </div>
      <TitleWithBorder>Новости проекта</TitleWithBorder>
      <div className="news-list">
        {items.map((article, index) => {
          const publicNewsMonth = getMonthTitle(article.meta.published_at)

          return (
            <Fragment key={index}>
              {!publicNewsMonth.wasShown && (
                <p className="public-month-title">{publicNewsMonth.value}</p>
              )}
              <NewsItem key={index} {...article} />
            </Fragment>
          )
        })}
      </div>
      {total_count > items.length && (
        <Button isGrey onClick={fetchMore} isLoader={isLoading}>
          Загрузить ещё
        </Button>
      )}
    </Wrapper>
  )
}

export default NewsList
